import React from 'react';
import { Lightbulb, Box, Settings, RotateCcw, FileText, RefreshCw, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';
import { serviceImages } from '../data/images';

const iconMap = {
  Lightbulb: Lightbulb,
  Box: Box,
  Settings: Settings,
  RotateCcw: RotateCcw,
  FileText: FileText,
  RefreshCw: RefreshCw
};

const ServicesPage = () => {
  return (
    <div className="services-page">
      {/* Hero Section - Industrial Style */}
      <section style={{
        padding: '140px 0 80px',
        background: 'var(--bg-page)',
        textAlign: 'center'
      }}>
        <div className="container-main">
          <span className="section-label">Our Services</span>
          <h1 className="hero-industrial-title" style={{ marginBottom: '1rem' }}>
            Comprehensive<br />Mechanical Design Solutions
          </h1>
          <p className="hero-industrial-subtitle" style={{ margin: '0 auto' }}>
            From concept to design-for-manufacture, we deliver excellence at every stage
          </p>
        </div>
      </section>

      {/* Services Grid - Industrial Design */}
      <section className="section-padding" style={{ background: 'var(--bg-section-alt)' }}>
        <div className="container-main">
          <div className="services-industrial-grid">
            {services.map((service, idx) => {
              const IconComponent = iconMap[service.icon];

              return (
                <div key={service.id} className="service-card-industrial">
                  <div className="service-card-industrial-image">
                    <img
                      src={serviceImages[idx]}
                      alt={service.title}
                    />
                    <div className="service-icon-badge">
                      <IconComponent size={32} />
                    </div>
                  </div>

                  <div className="service-card-industrial-body">
                    <h3 className="service-card-industrial-title">{service.title}</h3>
                    <p className="service-card-industrial-text">
                      {service.description}
                    </p>
                    
                    <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.25rem' }}>
                      {service.features.slice(0, 3).map((feature, idx) => (
                        <li key={idx} style={{
                          color: 'var(--text-secondary)',
                          marginBottom: '0.5rem',
                          lineHeight: 1.6
                        }}>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <span className="service-read-more">
                      Learn More <ArrowRight size={18} />
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
